import script from "./sideNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./sideNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./sideNavbar.vue?vue&type=style&index=0&id=3a004f7f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a004f7f"]])

export default __exports__